import { useRef, useEffect } from "react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export default function TextEffectLines({ title }) {
  const textRef = useRef();

  useEffect(() => {
    const text = textRef.current;
    text.innerHTML = "";

    const lines = title.split("<br>");
    lines.forEach((line, index) => {
      const lineContainer = document.createElement("div");
      lineContainer.className = "line";

      line.split("").forEach((letter) => {
        const span = document.createElement("span");
        span.textContent = letter;
        lineContainer.appendChild(span);
      });

      text.appendChild(lineContainer);
      if (index < lines.length - 1)
        text.appendChild(document.createElement("br"));
    });

    gsap.fromTo(
      ".typing-text span",
      { opacity: 0 },
      {
        opacity: 1,
        duration: 0.3,
        stagger: 0.08,
        ease: "power2.inOut",
        scrollTrigger: {
          trigger: textRef.current,
          start: "top 80%",
          toggleActions: "play none none reverse",
        },
      }
    );
  }, [title]);

  return (
    <h2
      ref={textRef}
      className="typing-text text-2xl md:text-5xl font-bold text-center "
    >
      콘텐츠 자동화, 결국 성과로 말해야 합니다.
    </h2>
  );
}
